import { Routes } from '@angular/router';
import { IamAction } from 'src/app/models/permission';

export const configRoutes: Routes = [
  {
    path: 'broadcast',
    data: { moduleCode: 'config_broadcast' },
    children: [
      { path: '', loadComponent: () => import('./broadcast/broadcast').then((m) => m.Broadcast) },
      { path: 'add', loadComponent: () => import('./broadcast/broadcast-details/broadcast-details').then((m) => m.BroadcastDetails) },
      {
        path: 'details/:id',
        loadComponent: () => import('./broadcast/broadcast-details/broadcast-details').then((m) => m.BroadcastDetails)
      }
    ]
  },

  {
    path: 'domain-whitelist',
    data: { moduleCode: 'config_domain_whitelist' },
    children: [
      { path: '', loadComponent: () => import('./domain-whitelist/domain-whitelist').then((m) => m.DomainWhitelist) },
      {
        path: 'add',
        loadComponent: () =>
          import('./domain-whitelist/domain-whitelist-details/domain-whitelist-details').then((m) => m.DomainWhitelistDetails)
      },
      {
        path: 'details/:id',
        loadComponent: () =>
          import('./domain-whitelist/domain-whitelist-details/domain-whitelist-details').then((m) => m.DomainWhitelistDetails)
      }
    ]
  },

  {
    path: 'user-online',
    data: { moduleCode: 'usr_online' },
    children: [
      { path: '', loadComponent: () => import('./user-online/user-online').then((m) => m.UserOnline) },
      {
        path: 'details/:id',
        loadComponent: () => import('./user-online/user-online-details/user-online-details').then((m) => m.UserOnlineDetails)
      }
    ]
  },

  {
    path: 'device-license',
    data: { moduleCode: 'config_device_lic' },
    children: [
      { path: '', loadComponent: () => import('./device-license/device-license').then((m) => m.DeviceLicense) },
      {
        path: 'details/:id',
        loadComponent: () => import('./device-license/device-license-details/device-license-details').then((m) => m.DeviceLicenseDetails)
      }
    ]
  },

  {
    path: 'language',
    data: { moduleCode: 'config_lang_main' },
    children: [
      { path: '', loadComponent: () => import('./language-maintenance/language-maintenance').then((m) => m.LanguageMaintenance) },
      { path: 'add', loadComponent: () => import('./language-maintenance/language-add/language-add').then((m) => m.LanguageAdd) },
      { path: 'edit/:id', loadComponent: () => import('./language-maintenance/language-edit/language-edit').then((m) => m.LanguageEdit) }
    ]
  },

  {
    path: 'country',
    data: { moduleCode: 'country' },
    children: [{ path: '', loadComponent: () => import('./country/country').then((m) => m.Country) }]
  },

  {
    path: 'state',
    data: { moduleCode: 'state' },
    children: [
      { path: '', loadComponent: () => import('./state/state').then((m) => m.State) },
      { path: 'add', loadComponent: () => import('./state/state-details/state-details').then((m) => m.StateDetails) },
      { path: 'details/:id', loadComponent: () => import('./state/state-details/state-details').then((m) => m.StateDetails) }
    ]
  },

  {
    path: 'region',
    data: { moduleCode: 'region' },
    children: [
      { path: '', loadComponent: () => import('./region/region').then((m) => m.Region) },
      { path: 'add', loadComponent: () => import('./region/region-details/region-details').then((m) => m.RegionDetails) },
      { path: 'details/:id', loadComponent: () => import('./region/region-details/region-details').then((m) => m.RegionDetails) }
    ]
  },

  {
    path: 'document-number-series',
    data: { moduleCode: 'config_num_series' },
    children: [
      { path: '', loadComponent: () => import('./number-series/document-number-series').then((m) => m.NumberSeries) },
      {
        path: 'add',
        loadComponent: () => import('./number-series/number-series-details/number-series-details').then((m) => m.NumberSeriesDetails)
      },
      {
        path: 'details/:id',
        loadComponent: () => import('./number-series/number-series-details/number-series-details').then((m) => m.NumberSeriesDetails)
      }
    ]
  },

  {
    path: 'reason-maintenance',
    data: { moduleCode: 'config_rsn_main' },
    children: [
      { path: '', loadComponent: () => import('./reason-maintenance/reason-maintenance').then((m) => m.ReasonMaintenance) },
      {
        path: 'add',
        loadComponent: () =>
          import('./reason-maintenance/reason-maintenance-details/reason-maintenance-details').then((m) => m.ReasonMaintenanceDetails)
      },
      {
        path: 'details/:id',
        loadComponent: () =>
          import('./reason-maintenance/reason-maintenance-details/reason-maintenance-details').then((m) => m.ReasonMaintenanceDetails)
      }
    ]
  },

  {
    path: 'number-series-change-requests',
    data: { moduleCode: 'config_req_nsc' },
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./number-series-change-requests/number-series-change-requests').then((m) => m.NumberSeriesChangeRequest)
      },
      {
        path: 'details/:id',
        loadComponent: () =>
          import('./number-series-change-requests/number-series-change-requests-details/number-series-change-requests-details').then(
            (m) => m.NumberSeriesChangeRequestDetails
          )
      }
    ]
  },

  {
    path: 'new-broadcast-creation-request',
    data: { moduleCode: 'config_req_broadcast' },
    children: [
      { path: '', loadComponent: () => import('./broadcast-requests/broadcast-requests').then((m) => m.BroadcastRequests) },
      {
        path: 'details/:id',
        loadComponent: () =>
          import('./broadcast-requests/broadcast-requests-details/broadcast-requests-details').then((m) => m.BroadcastRequestsDetails)
      }
    ]
  },

  {
    path: 'broadcast-details-update-request',
    data: { moduleCode: 'config_req_broadcast_upd' },
    children: [
      { path: '', loadComponent: () => import('./update-broadcast-req/update-broadcast-req').then((m) => m.UpdateBroadcastReq) },
      {
        path: 'details/:id',
        loadComponent: () =>
          import('./update-broadcast-req/update-broadcast-req-details/update-broadcast-req-details').then(
            (m) => m.UpdateBroadcastReqDetails
          )
      }
    ]
  },

  {
    path: 'document-preset',
    data: { moduleCode: 'config_doc_preset' },
    children: [
      { path: '', loadComponent: () => import('./document-preset/document-preset').then((m) => m.DocumentPreset) },
      {
        path: 'add',
        loadComponent: () =>
          import('./document-preset/document-preset-details/document-preset-details').then((m) => m.DocumentPresetDetails)
      },
      {
        path: 'details/:id',
        loadComponent: () =>
          import('./document-preset/document-preset-details/document-preset-details').then((m) => m.DocumentPresetDetails)
      }
    ]
  },

  {
    path: 'document-template',
    data: { moduleCode: 'config_doc_temp' },
    children: [
      { path: '', loadComponent: () => import('./document-template/document-template').then((m) => m.DocumentTemplate) },
      {
        path: 'details/:id',
        loadComponent: () =>
          import('./document-template/document-template-details/document-template-details').then((m) => m.DocumentTemplateDetails)
      }
    ]
  },

  {
    path: 'localization-maintenance',
    data: { moduleCode: 'config_local_main' },
    children: [
      {
        path: '',
        loadComponent: () => import('./localization-maintenance/localization-maintenance').then((m) => m.LocalizationMaintenance)
      },
      {
        path: 'add',
        loadComponent: () =>
          import('./localization-maintenance/localization-maintenance-details/localization-maintenance-details').then(
            (m) => m.LocalizationMaintenanceDetails
          )
      },
      {
        path: 'details/:id',
        loadComponent: () =>
          import('./localization-maintenance/localization-maintenance-details/localization-maintenance-details').then(
            (m) => m.LocalizationMaintenanceDetails
          )
      },
      {
        path: 'details/:id/number-series/:seriesId',
        loadComponent: () =>
          import(
            './localization-maintenance/localization-maintenance-details/localization-number-series/localization-number-series-details/localization-number-series-details'
          ).then((m) => m.LocalizationNumberSeriesDetails)
      }
    ]
  },

  {
    path: 'license-request',
    data: { moduleCode: 'config_req_lic_adj' },
    children: [
      { path: '', loadComponent: () => import('./license-request/license-request').then((m) => m.LicenseRequest) },
      {
        path: 'details/:type/:id',
        loadComponent: () =>
          import('./license-request/license-request-details/license-request-details').then((m) => m.LicenseRequestDetails)
      }
    ]
  },

  {
    path: 'payment-method',
    data: { moduleCode: 'pymt_mth' },
    children: [
      { path: '', loadComponent: () => import('./payment-method/payment-method').then((m) => m.PaymentMethod) },
      {
        path: 'add',
        loadComponent: () => import('./payment-method/payment-method-details/payment-method-details').then((m) => m.PaymentMethodDetails)
      },
      {
        path: 'details/:id',
        loadComponent: () => import('./payment-method/payment-method-details/payment-method-details').then((m) => m.PaymentMethodDetails)
      },
      { path: 'pm-import', loadComponent: () => import('./payment-method/pm-import/pm-import').then((m) => m.PmImport) }
    ]
  },

  {
    path: 'kyb-document-type',
    data: { moduleCode: 'kyb_doc_type' },
    children: [
      { path: '', loadComponent: () => import('./kyb-doctype/kyb-doctype').then((m) => m.KybDoctype) },
      {
        path: 'add',
        loadComponent: () => import('./kyb-doctype/kyb-doctype-details/kyb-doctype-details').then((m) => m.KybDoctypeDetails)
      },
      {
        path: 'details/:id',
        loadComponent: () => import('./kyb-doctype/kyb-doctype-details/kyb-doctype-details').then((m) => m.KybDoctypeDetails)
      },
      { path: 'import', loadComponent: () => import('./kyb-doctype/kyb-import/kyb-import').then((m) => m.KybImport) }
    ]
  },

  {
    path: 'bank',
    data: { moduleCode: 'bank_list' },
    children: [
      { path: '', loadComponent: () => import('./bank/bank').then((m) => m.Bank) },
      { path: 'add', loadComponent: () => import('./bank/bank-details/bank-details').then((m) => m.BankDetails) },
      { path: 'details/:id', loadComponent: () => import('./bank/bank-details/bank-details').then((m) => m.BankDetails) },
      { path: 'import', loadComponent: () => import('./bank/bank-import/bank-import').then((m) => m.BankImport) }
    ]
  },

  {
    path: 'general-number-series',
    data: { moduleCode: 'config_gen_num_series' },
    children: [
      { path: '', loadComponent: () => import('./general-number-series/general-number-series').then((m) => m.GeneralNumberSeries) },
      {
        path: 'add',
        loadComponent: () =>
          import('./general-number-series/general-number-series-details/general-number-series-details').then(
            (m) => m.GeneralNumberSeriesDetails
          )
      },
      {
        path: 'details/:id',
        loadComponent: () =>
          import('./general-number-series/general-number-series-details/general-number-series-details').then(
            (m) => m.GeneralNumberSeriesDetails
          )
      }
    ]
  },
  {
    path: 'msic',
    data: { moduleCode: 'config_msic' },
    children: [
      { path: '', loadComponent: () => import('./msic/msic').then((m) => m.Msic) },
      { path: 'add', loadComponent: () => import('./msic/msic-details/msic-details').then((m) => m.MsicDetails) },
      { path: 'details/:id', loadComponent: () => import('./msic/msic-details/msic-details').then((m) => m.MsicDetails) },
      { path: 'import', loadComponent: () => import('./msic/msic-import/msic-import').then((m) => m.MsicImport) }
    ]
  },
  {
    path: 'workflow',
    data: { moduleCode: 'config_workflow' },
    children: [
      { path: '', loadComponent: () => import('./workflow/workflow').then((m) => m.Workflow) },
      {
        path: 'add/:id',
        loadComponent: () => import('./workflow/workflow-canvas/workflow-canvas').then((m) => m.WorkflowCanvasComponent),
        data: { permission: IamAction.CREATE }
      },
      {
        path: 'details/:id',
        loadComponent: () => import('./workflow/workflow-canvas/workflow-canvas').then((m) => m.WorkflowCanvasComponent)
      }
    ]
  },
  {
    path: 'general-number-series-request',
    data: { moduleCode: 'config_gen_num_series_req' },
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./general-number-series-request/general-number-series-request').then((m) => m.GeneralNumberSeriesRequest)
      },
      {
        path: 'details/:id',
        loadComponent: () =>
          import('./general-number-series-request/general-number-series-request-details/general-number-series-request-details').then(
            (m) => m.GeneralNumberSeriesReqDetails
          )
      }
    ]
  },
  //Credit Terms
  {
    path: 'credit-terms',
    data: { moduleCode: 'config_credit_term' },
    children: [
      { path: '', loadComponent: () => import('./credit-terms/credit-terms').then((m) => m.CreditTerms) },
      {
        path: 'add',
        loadComponent: () => import('./credit-terms/credit-terms-details/credit-terms-details').then((m) => m.CreditTermsDetails)
      },
      {
        path: 'details/:id',
        loadComponent: () => import('./credit-terms/credit-terms-details/credit-terms-details').then((m) => m.CreditTermsDetails)
      },
      {
        path: 'credit-terms-import',
        loadComponent: () => import('./credit-terms/credit-terms-import/credit-terms-import').then((m) => m.CreditTermsImport)
      }
    ]
  },
  // Payment Terms
  {
    path: 'payment-terms',
    data: { moduleCode: 'config_payment_term' },
    children: [
      { path: '', loadComponent: () => import('./payment-terms/payment-terms').then((m) => m.PaymentTerms) },
      {
        path: 'add',
        loadComponent: () => import('./payment-terms/payment-terms-details/payment-terms-details').then((m) => m.PaymentTermsDetails)
      },
      {
        path: 'details/:id',
        loadComponent: () => import('./payment-terms/payment-terms-details/payment-terms-details').then((m) => m.PaymentTermsDetails)
      },
      {
        path: 'payment-import',
        loadComponent: () => import('./payment-terms/payment-terms-import/payment-terms-import').then((m) => m.PaymentTermsImport)
      }
    ]
  },
  // Risk Tier
  {
    path: 'risk-tier-blacklist-reason',
    data: { moduleCode: 'config_risk_blacklist' },
    children: [
      { path: '', loadComponent: () => import('./risk-tier/risk-tier').then((m) => m.RiskTier) },
      {
        path: 'risk-tier/add',
        loadComponent: () => import('./risk-tier/risk-tier-details/risk-tier-details').then((m) => m.RiskTierDetails)
      },
      {
        path: 'risk-tier/details/:id',
        loadComponent: () => import('./risk-tier/risk-tier-details/risk-tier-details').then((m) => m.RiskTierDetails)
      },
      {
        path: 'blacklist-reason/add',
        loadComponent: () => import('./risk-tier/risk-tier-details/risk-tier-details').then((m) => m.RiskTierDetails)
      },
      {
        path: 'blacklist-reason/details/:id',
        loadComponent: () => import('./risk-tier/risk-tier-details/risk-tier-details').then((m) => m.RiskTierDetails)
      },
      {
        path: 'risk-tier/import',
        loadComponent: () => import('./risk-tier/risk-tier-import/risk-tier-import').then((m) => m.RiskTierImport)
      },
      {
        path: 'blacklist-reason/import',
        loadComponent: () => import('./risk-tier/risk-tier-import/risk-tier-import').then((m) => m.RiskTierImport)
      }
    ]
  }
];
